import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonLibraryBuiltInRepositoryOverview, CommonLibraryBuiltInRepositoryTopics } from "../../CommonComponents/CommonLibraryBuiltInRepositoryViews";

export const LibraryBuiltInRepositoryPackageRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.builtInRepository.package,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryBuiltInRepositoryOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryBuiltInRepositoryTopics />;
    },
};
